import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AbstractionComponent } from "@biletix/core/common/abstraction-component";

@Component({
  selector: 'btx-venue-stay22',
  templateUrl: './stay22.component.html',
  styleUrls: ['./stay22.component.scss'],
  standalone: false
})
export class VenueStay22Component extends AbstractionComponent implements OnInit, OnChanges {
  stay22UrlSafe!: SafeResourceUrl;

  @Input() campaignID = 'venuepage';
  @Input() itemLat = '';
  @Input() itemLong = '';
  @Input() itemVenue = '';

  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit(): void {
    this.buildStay22Url();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.buildStay22Url();
  }

  private buildStay22Url(): void {
    const campaign = this.campaignID || 'venuepage';
    const lat = this.itemLat || '';
    const lng = this.itemLong || '';
    const venue = encodeURIComponent(this.itemVenue || '');
    
    const rawUrl = `https://www.stay22.com/embed/gm?aid=biletixticketmasterturkey&campaign=${campaign}&maincolor=1F262D&navimage=https://www.biletix.com/static/images/tm-logo-stay22.png&lat=${lat}&lng=${lng}&venue=${venue}`;
    this.stay22UrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);
  }
}
